var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Customer"},[(_vm.img)?_c('img',{attrs:{"src":_vm.img,"alt":""}}):_c('div',[_vm._v("运营商暂未上传客服二维码")])])}
var staticRenderFns = []

export { render, staticRenderFns }